goog.provide("shadow.js.shim.module$src$svg$inform$error_diamond_fill_svg$default");
shadow.js.shim.module$src$svg$inform$error_diamond_fill_svg$default = shadow.js.shim.module$src$svg$inform$error_diamond_fill_svg.default;
